import { Loader } from "./loader";
import styles from "./loader.module.css";

export const PageLoader = () => {
    return (
        <div className={styles.loader_container}>
            <Loader />
        </div>
    )
}